<template>
  <div class="content">
    <section v-if="$route.params.bookid">
      <div class="container keymapped" tabindex="0"
           @keyup.n="previewPostNext"
           @keyup.p="previewPostPrev"
           @keyup.arrow-right="previewNext"
           @keyup.arrow-left="previewPrev"> 
        <div id="preview-area" class="box">
          
          <div id="preview-holder-outer" :class="'format-'+book.format">
            <div id="preview-holder">
              <div class="preview-box">
                <flip-book class="aspect-box"
                           :format="book.format"
                           :pages="previewPages"
                           :pagenum.sync="previewPageNumber">
                  <template slot-scope="page">
                    <div class="page">
                      <div class="blank" v-if="page.content.pid=='_blank'">
                        &mdash; blank page &mdash;
                      </div>
                      <div v-else class="contents fit-parent" :class="{pending: page.content.pending}">
                        <img v-if="page.content.img"
                             :src="page.content.img"
                             :style="'transform: translateY(-'+(page.content.offset*100.0)+'%);'"/>
                        <div v-else class="loading fit-parent">Loading</div>
                      </div>
                    </div>
                  </template>
                </flip-book>
              </div>
            </div>
          </div>

          <div>
            <div class="hbox">
              <div class="buttonbox">
                <a class="button is-outlined" @click="previewPostPrev()">&lt;&lt;</a>
                <a class="button is-outlined" @click="previewPrev()">&lt;</a>
                <a class="button is-outlined" @click="previewNext()">&gt;</a>
                <a class="button is-outlined"
                 @click="previewPostNext()">&gt;&gt;</a>
              </div>
              <div class="slider">
                <b-slider v-model="previewPageNumber" :tooltip="false"
                            :min="0" :max="Math.max(previewPages.length, 0)" :step="2"/>
              </div>
            </div>
          </div>

          <!--a class="float-br button is-primary is-large"
             @click="showPrintDialog = true" disabled>
            <b-icon icon="cart"/>
            <span>Buy</span>
          </a-->
        </div>
      
      <div class="box tile is-ancestor">
        <div class="is-info tile is-parent">
          <div class="tile is-child">
            <h3 class="subtitle">{{book.title}}<span v-if="book.author"> - {{book.author}}</span></h3>
            <div style="max-width: 20em;">
              <div v-if="book.blurb" v-html="book.blurb"/>
              This book was created from the blog
              <a :href="'http://'+book.site" target="_blank" rel="nofollow">http://{{book.site}}</a>
              <span v-if="book.date"> on <em>{{book.date | formatDate}}</em></span>
            </div>
          </div>
          <div class="tile is-child">
            <ul>
              <li>A4 hardback photo quality.</li>
              <li>{{contentPageCount}} pages.</li>
              <li>{{$store.state.currencySymbol}}{{price | formatCurrency}} plus postage</li>
            </ul>
          </div>
          <div class="tile is-child">
            <a class="button is-primary" v-if="canBuy"
               @click="addToCart">
              <b-icon icon="cart"/>
              <span>Buy this Book</span>
            </a>
          </div>
        </div>
      </div>
      </div>
      <hr class="spacer">
    </section>

    <section id="examples" v-if="!canBuy">
      <div class="container">
        <h1 class="title has-text-centered">
          {{$route.params.bookid ? 'Some Other Books': 'Gallery' }}</h1>
          <div id="gallery">
            <gallery-card v-for="book in thumbBooks" :key="book.id"
                          class="gallery-card"
                          :bookid="book.id" :desc="book.desc"/>
          </div>
          <div v-if="$route.params.bookid" class="see-more">
            <router-link to="/gallery">See more in the gallery...</router-link>
          </div>
          <div v-else class="see-more">
            <router-link to="/doc/formats">Discover more about our quality books...</router-link>
          </div>
      </div>
    </section>

    <section id="padding">
      <div class="container box">
        <index-launcher title="Make your own blog book:"></index-launcher>
      </div>
    </section>
  </div>
</template>

<script>
import FlipBook from '@/components/FlipBook'
import GalleryCard from '@/components/GalleryCard'
import IndexLauncher from '@/components/IndexLauncher'
import Pricer from '../pricer.js'
import ActionLog from '../actionlog.js'
import Firebase from '../firebase.js'
import { GalleryItems } from '../promotion.js'
var db = Firebase.database

export default  {
  name: "GalleryPage",
  metaInfo() { return {
    title: this.pageTitle,
    meta: this.ogMeta,
  }},
  components: {
    FlipBook,
    GalleryCard,
    IndexLauncher,
  },
  data: function() { return {
    previewPageNumber: 0,
    thumbBooks: [],
    book: {},
  }},
  computed: {
    previewPages: function() { return this.book.pages || []; },
    // Content pages excluding covers (front cover, inside front cover, inside back cover, back cover)
    contentPageCount: function() { return this.previewPages.length - 4; },
    price: function() { return Pricer.calculatePrice('a4', this.contentPageCount, this.$store.state.currency) },
    numThumbs: function() { return this.$route.params.bookid ? 4 : 7 },
    pageTitle: function() {
      if (this.book && this.book.title) { return 'Book: '+ this.book.title }
      return 'Blog Book Gallery'
    },
    ogMeta: function() {
      var meta = []
      meta.push({ vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' })
      if (this.pageTitle) meta.push({ vmid: 'og:title', name: 'og:title', content: this.pageTitle })
      if (this.book.site) meta.push({ vmid: 'og:description', name: 'og:description',
                                      content: 'This book was created from the blog http://'+this.book.site })
      if (this.previewPages.length) meta.push({ vmid: 'og:image', name: 'og:image',
                                                content: this.previewPages[0].img })
      return meta
    },
    canBuy: function() {
      return this.book && this.book.buyable
    },
  },
  methods: {
    loadBook: function() {
      if (this.$route.params.bookid) {
        this.$bindAsObject("book", db.ref('/gallery/'+this.$route.params.bookid))
        this.previewPageNumber = 0
      }
      this.thumbBooks = GalleryItems.filter(id => id != this.$route.params.bookid).slice(0, this.numThumbs)
    },
    previewPrev : function() {
      if (this.previewPageNumber > 1) { this.previewPageNumber-=2; }
    },
    previewNext : function() {
      if (this.previewPageNumber < this.previewPages.length-1) { this.previewPageNumber+=2; }
    },
    previewPostPrev : function() {
      var pageNo = this.previewPageNumber
      if (pageNo > 1) {
        var pid = this.previewPages[pageNo-1].pid
        if (this.previewPages[pageNo-1].page != 0) {
          // find start of post already on left hand page
          pid = -1
        }
        do {
          pageNo -= 2;
        } while (pageNo > 1
                 && (this.previewPages[pageNo].pid==pid || this.previewPages[pageNo].page!=0)
                 && (this.previewPages[pageNo-1].pid==pid || this.previewPages[pageNo-1].page!=0))
        this.previewPageNumber = pageNo
      }
    },
    previewPostNext : function() {
      var pageNo = this.previewPageNumber
      if (pageNo < this.previewPages.length-2) {
        var pid = this.previewPages[pageNo].pid
        do {
          pageNo += 2;
        } while (pageNo < this.previewPages.length-2
                 && this.previewPages[pageNo].pid==pid
                 && this.previewPages[pageNo-1].pid==pid)
        this.previewPageNumber = pageNo
      }
    },
    addToCart: function() {
      const shopid = this.$route.params.shopid
      const bookid = 'gallery::'+this.$route.params.bookid
      this.$store.dispatch('addToCart', { bookid: bookid, quantity: -1 })
      ActionLog('gallery_checkout', { shopid, bookid })
      if (shopid) {
        this.$router.push('/checkout?shop='+shopid)
      } else {
        this.$router.push('/checkout')
      }
    },
  },
  watch: {
    '$route.params.bookid': function() {
      this.loadBook()
    }
  },
  beforeMount: function() {
    this.loadBook()
  },
  beforeRouteUpdate(to, from, next) {
    console.log('afterRouteUpdate', to, from)
    this.loadBook()
    next()
  },
}
</script>


<style scoped>
#maincontent {
    padding-top: 0.5rem;
}
.keymapped {
    /* kill focus active border */
    outline: none;
}
#preview-area {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f8f3e6;
}
#preview-holder-outer {
    max-width: 100%;
}
#preview-holder {
    margin: 1em;
} 
.format-a4 #preview-holder {
    max-width: 100vh;
}
.format-pa4 #preview-holder {
    max-width: 100vh;
}
.format-a4r #preview-holder {
    max-width: 200vh;
}
.format-sq #preview-holder {
    max-width: 150vh;
}
.preview-box {
    width: 75vh;
    max-width: 100%;
    display: inline-block;
    position: relative;
}
.aspect-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.page-container {
    width: 100%;
    padding: 1em;
}
.page-holder {
    margin: 0;
}
.page {
    width:100%;
    height: 100%;
    overflow: hidden;
}
.page-small.page-sizer {
    /*width: 400px; height: 564px;*/
    width: 200px; height: 282px;
}
.page .blank {
    width: 100%;
    height: 100%;
    color: #ccc;
    font-size: 80%;
    padding: 40% 2em 0 2em;
}
.page .loading {
     background: url(/static/loading_spinner.gif) no-repeat center center #fff;
}
.fit-parent {
     width: 100%;
     height: 100%;
}
.page .contents {
    background: url(/static/loading_spinner.gif) no-repeat center center #fff;
}
.page .contents img {
    width:100%;
}
.page .contents.pending img {
    opacity: 0.5;
}
.hbox {
    display: flex;
    width: 100%;
}
.slider {
    margin-left: 1rem;
    margin-right: 1rem;
    width: 14rem;
    max-width: 40vw;
}
.button {
    margin-bottom: 0.5rem;
}

.float-br.button {
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 0.5rem;
}

section {
    margin-top: 1em;
}
.content hr.spacer {
    margin: 3em;
    visibility: hidden;
}
.see-more {
    text-align: right;
    padding-right: 2em;
}

#gallery {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
#gallery .gallery-card {
    margin: 1em;
    width: 20%;
    min-width: 13rem;
    max-width: 20rem;
}
</style>



// WEBPACK FOOTER //
// src/components/GalleryPage.vue